export default __webpack_public_path__ + "a0f4b2473b768feb7d97de010a3eedd9.png";